import {AsyncActDecorator} from '@gongxigames/framework/slotV2/fsm/acts/decorators/AsyncActDecorator';

export class SystemInitializedAct extends AsyncActDecorator {
    public async execute(): Promise<void> {
        this.emitter.emit('General.Game.SYSTEM_INITIALIZED');
        this.eventManager.emit('General.Game.SYSTEM_INITIALIZED');
    }

    getName(): string {
        return 'SystemInitializedAct';
    }
}